import { Button } from 'theme-ui';

import { Svg } from '@snippets';
import { useSidebar } from '@hooks';

import { useSearchInput } from '@snippets/Search/hooks';
import { themed } from '../Menu.theme';

export const CtaSearch = themed(({ theme, inputRef, adminLinksColor, ...props }) => {
  const [{}, { openSearchSidebar }] = useSidebar();
  const [{}, { resetRawTerm }] = useSearchInput();

  const buttonClickHandler = () => {
    openSearchSidebar();
    resetRawTerm();
  };

  return (
    <Button
      data-comp={CtaSearch.displayName}
      {...props}
      variant="buttons.plain"
      aria-label="Open search"
      onClick={buttonClickHandler}
      sx={{
        ...props.sx,
        ...theme.cta,
      }}
    >
      <Svg
        alt="Open search"
        viewBox="0 0 48 48"
        src="/svgs/cta/search.svg#search"
        sx={{ ...theme.cta.icon, color: adminLinksColor }}
      />
    </Button>
  );
});

CtaSearch.displayName = 'CtaSearch';